import React, { useContext, useEffect, useState } from "react";

import { ReactComponent as Personal } from "../../assets/icons/personal.svg";
import { ReactComponent as Business } from "../../assets/icons/business.svg";
import { ReactComponent as Close } from "../../assets/icons/x.svg";
import { ReactComponent as Check } from "../../assets/icons/check.svg";
import { Loader } from "react-feather";
import ReactDOM from "react-dom";
import AccountCreated from "./AccountCreated";
import { NotificationContext } from "../../Context/NotificationContext";
import { AuthContext } from "../../Context/AuthContext";
import { FormTextInput } from "../../Components/FormTextInput";
import "./CreateAccount.css";
import { AccountType, EAST4 } from "../../utility/enums";
import { auth, firestore, getFullHttpUrl } from "../../firebase.config";
import axios from "axios";
import { useLocation } from "react-router-dom";
import { getQueryParam, useScreenTransition } from "../../Hooks/useScreenTransition";
import { isHowDidYouHearAnswered, updateHowDidYouHearData } from "../../Data/Functions/HowDidYouHear";
import HowDidYouHearSelect from "../../NewComponents/HowDidYouHearSelect";
import { v4 as uuidv4 } from "uuid";
import authHeaders from "../../utility/authHeaders";
import { EXPIRED_LINK_MESSAGE, announceJoin, getInviteLink, holdJoin, joinTeamWithLink, releaseJoin } from "../../utility/teamInviteLinks";
import { goToLanding } from "../../utility/landing";
import { useCheckoutT } from "../../i18n/checkout";
import { forgetReferral, getCodeInfo, normalizeCode, referralBenefit, referralFrom, rememberReferral, storedReferral } from "../../utility/referrals";
import EmailTypoHint from "../../NewComponents/EmailTypoHint";
import { emailTypoFix } from "../../utility/emailTypos";
import { personName } from "../../utility/personName";

export default function CreateAccount({
  open,
  isCreateAccountOpen,
  isLoginFormOpen,
  showSelectAccountType = true,
  accountType = "personal",
  width = "792px",
  // false on pages that keep the person where they are (checkout, an order
  // or quote page): the form closes instead of going to the account.
  pageRedirect = true,
}) {
  const modalRoot = document.getElementById("modal-root");
  const [userInf, setUserInf] = useState({
    firstName: "",
    lastName: "",
    companyName: "",
    email: "",
    password: "",
  });

  const [accoutTypeSelected, setAccountTypeSelected] = useState(accountType);
  const [accountStatus, setAccountStatus] = useState("not-created");
  const [isLoading, setIsLoading] = useState(false);
  const [showPassError, setShowPassError] = useState(false);
  const { showNotification } = useContext(NotificationContext);
  // English everywhere but the checkout (see i18n/checkout).
  const { t } = useCheckoutT();
  // The button's text, by key (see i18n/checkout/strings/account.js).
  const [submitButton, setSubmitButton] = useState("account.create.button");
  const { setSignedIn } = useContext(AuthContext);
  const [emailError, setEmailError] = useState(false);
  const [passwordError, setPasswordError] = useState(false);
  const [marketingCampaignData, setMarketingCampaignData] = useState(null);
  const { signedIn } = useContext(AuthContext);
  const { transitionTo } = useScreenTransition();
  const now = new Date();
  const localMarketingData = JSON.parse(localStorage.getItem("marketingCampaignData"));
  const localMarketingId = localMarketingData ? localMarketingData.isValid > now.getTime() && localMarketingData.id : null;
  const marketingCampaignId= getQueryParam("business")?? localMarketingId;
  const createAccountParam= getQueryParam("create-account");
  const joinTeamParam= getQueryParam("join-team");
  const joinTeamToken= getQueryParam("token");
  const referralParam = getQueryParam("ref");
  // Another firm's referral link (/r/<code>): the firm that invited them and
  // the code, which the server checks when it creates the team.
  const [referral, setReferral] = useState(null);
  const [showReferralField, setShowReferralField] = useState(false);
  const [referralInput, setReferralInput] = useState("");
  const [referralInputError, setReferralInputError] = useState(false);
  // "How did you hear about us?" for personal accounts and new teams alike;
  // not for someone joining their team from an invite link.
  const askHear = !(joinTeamParam && joinTeamToken);

  const [joinTeamData, setJoinTeamData] = useState(null);

  const [selectedOption, setSelectedOption] = useState("");
  const [showInputOption, setShowInputOption] = useState(false);
  const [optionInput, setOptionInput] = useState("");



  const closeModel = () => {
    isCreateAccountOpen(false);
    setEmailError(false);
    setPasswordError(false);
    setShowPassError(false);
    setIsLoading(false);
  };

  const openLoginForm = () => {
    isCreateAccountOpen(false);
    isLoginFormOpen(true);
  };

  const closeAccountCreated = () => {
    setAccountStatus("not-created");
    isCreateAccountOpen(false);
  };

  const updateMarketingCampaign = async (marketingampaignId) => {
    const marketingCampaignRef = firestore.collection("marketingCampaigns").doc(marketingampaignId);
    const docRef = await marketingCampaignRef.get();
    if(docRef.exists && docRef.data().active){
      const data = docRef.data();
      setMarketingCampaignData({...data, id: docRef.id});
    }
  }


  // The invite link's token (not a team ID) tells us which team to show.
  const getTeamData = async(joinTeamToken) => {
    const link = await getInviteLink(joinTeamToken);
    if(link){
      setJoinTeamData({ id: link.teamId, name: link.teamName });
      setUserInf({...userInf, companyName: link.teamName});
    }else{
      showNotification("Invite link expired", EXPIRED_LINK_MESSAGE, "error");
    }
  }


  useEffect(() => {
    if(!signedIn){
      if(joinTeamParam && joinTeamToken){
        setAccountTypeSelected("business");
        getTeamData(joinTeamToken);
      }
      if(marketingCampaignId && !joinTeamParam){
        setAccountTypeSelected("business");
        updateMarketingCampaign(marketingCampaignId);
        const date = new Date();
        date.setDate(date.getDate() + 7);
        const timeAfter7Days = date.getTime();
        console.log(timeAfter7Days)
        localStorage.setItem("marketingCampaignData", JSON.stringify({id: marketingCampaignId, isValid: timeAfter7Days}));
      }
      const referralCode = referralParam ? rememberReferral(referralParam) : storedReferral();
      if(referralCode && !joinTeamParam){
        setAccountTypeSelected("business");
        getCodeInfo(referralCode)
          .then((info) => {
            if(info && info.valid){
              setReferral(referralFrom(info));
            }else{
              forgetReferral();
            }
          })
          .catch(() => setReferral({ code: referralCode }));
      }
      if(createAccountParam === "true"){
        isCreateAccountOpen(true);
        isLoginFormOpen(false);
        
      }

    }
  }, [signedIn])

  const createUser = async(selectedType = "personal", isTeam = false) => {
    // Arriving with a team invite link: this form joins the team (below), not Home.
    const linkToken = isTeam && joinTeamParam && joinTeamToken ? joinTeamToken : null;
    holdJoin(linkToken);
    try {
      await auth.createUserWithEmailAndPassword(
          userInf.email.toLowerCase(),
          userInf.password
        )
        .then(async (credential) => {
          // As saved: "morgana " -> "Morgana" (utility/personName).
          const firstName = personName(userInf.firstName, { firstName: true });
          const lastName = personName(userInf.lastName);

          if(askHear){
            
            const howDidYouHear = {selectedOption: selectedOption??"", hasInput: showInputOption??false, inputText: optionInput??""};

            updateHowDidYouHearData(credential?.user?.uid, howDidYouHear, userInf.email, `${firstName} ${lastName}`.trim(), "",credential?.user?.uid);
          }

          const userDetails = {
            role: AccountType.CLIENT,
            name: `${firstName} ${lastName}`.trim(),
            email: userInf.email.toLowerCase(),
            firstName,
            lastName,
            timestamp: new Date().getTime(),
            // Picks the welcome email; the team itself is added by the server.
            accountType: isTeam ? "business" : "personal",
          }

          const docRef = firestore.collection("users").doc(credential.user.uid);

          await docRef.set(userDetails);

          // Business accounts either join the team of their invite link or get
          // a new team, both done by the server.
          let teamData = null;
          if(isTeam && joinTeamParam && joinTeamToken && joinTeamData){
            const status = await joinTeamWithLink(joinTeamToken).catch(() => null);
            announceJoin(status, showNotification);
            teamData = joinTeamData;
          }else if(isTeam){
            teamData = await createTeam();
          }

          if(isTeam && teamData && referralCodeToSend()){
            forgetReferral();
          }

          if(isTeam && teamData && marketingCampaignData){
            axios.post(getFullHttpUrl("updateMarketingCampaign", EAST4), {
              id: marketingCampaignData.id,
              teamId: teamData.id,
              teamName: teamData.name
            }, { headers: await authHeaders() })
  
            localStorage.removeItem("marketingCampaignData");
          }

          // New accounts start on their order list (a new team's owner is
          // then taken to the team's onboarding, see AccountNavBar).
          if(pageRedirect){
            setAccountStatus("created");
            goToLanding(transitionTo, "/account/orders");
          }else{
            closeAccountCreated();
          }

          setSignedIn(true);
          showNotification(
            t("notify.success"),
            t("account.create.created"),
            "success"
          );

          // await axios.post(
          //   getFullHttpUrl("onUserSignup"),
          //   {
          //     uid: credential.user.uid,
          //   }
          // );
        });
    } catch (error) {
      setIsLoading(false);
      setSubmitButton("account.create.button");
      console.log("error====>>>>>>>", error);
      var errorCode = error.code;

      switch (errorCode) {
        case "auth/email-already-in-use":
          showNotification(
            t("account.create.emailInUseTitle"),
            t("account.create.emailInUse"),
            "error"
          );
          break;
        case "auth/invalid-email":
          showNotification(
            t("notify.invalidEmail"),
            t("error.invalidEmail"),
            "error"
          );
          break;
        case "auth/weak-password":
          showNotification(
            t("account.create.weakPasswordTitle"),
            t("account.create.weakPassword"),
            "error"
          );
          break;
        default:
          showNotification(
            t("notify.error"),
            t("account.create.unexpected"),
            "error"
          );
      }
    } finally {
      releaseJoin(linkToken);
      setSubmitButton("account.create.button");
    }
  }

  const createPersonalAccount = async () => {
    if (userInf.email === "" || !/\S+@\S+\.\S+/.test(userInf.email)) {
      setEmailError(true);
      return;
    }

    if (userInf.password === "" || userInf.password.length < 6) {
      setPasswordError(true);
      return;
    }

    setSubmitButton("account.create.creatingDots");
    setIsLoading(true);

    createUser(accoutTypeSelected);
  };

  const triggerPersonalAccount = () => {
    if (
      accoutTypeSelected === "personal" &&
      !(
        userInf.firstName === "" ||
        userInf.lastName === "" ||
        userInf.email === "" ||
        userInf.password === "" ||
        userInf.password.length < 6
      )
    ) {
      createPersonalAccount();
    }
  };

  // The referral code the team is created with: the link's, or the one typed.
  const referralCodeToSend = () => (referral ? referral.code : normalizeCode(referralInput)) || null;

  // A typed code: checked when the field is left, so a typo shows up.
  const checkTypedReferral = async () => {
    const code = normalizeCode(referralInput);
    setReferralInputError(false);
    if(!code){
      return;
    }
    const info = await getCodeInfo(code).catch(() => null);
    if(info && info.valid){
      setReferral(referralFrom(info));
      setShowReferralField(false);
    }else if(info){
      setReferralInputError(true);
    }
  }

  // The server builds the team, taking any discount or free expedited
  // orders from the marketing campaign itself, not from the browser, and
  // checking the referral code.
  const createTeam = async() => {
    const referralCode = referralCodeToSend();
    const res = await axios.post(
      getFullHttpUrl("team-createTeamForSignup"),
      { companyName: userInf.companyName, marketingCampaignId: marketingCampaignData ? marketingCampaignData.id : null, ...(referralCode ? { referralCode } : {}) },
      { headers: await authHeaders() }
    );
    return res.data.team || (res.data.teamId ? { id: res.data.teamId, name: userInf.companyName } : null);
  }

  const createBusinessAccount = async () => {
    if (userInf.email === "" || !/\S+@\S+\.\S+/.test(userInf.email)) {
      setEmailError(true);
      return;
    }

    if (userInf.password === "" || userInf.password.length < 6) {
      setPasswordError(true);
      return;
    }

    setSubmitButton("account.create.creating");
    setIsLoading(true);

    createUser(accoutTypeSelected, true);
  };

  const triggerBusinessAccount = () => {
    if (
      accoutTypeSelected === "business" &&
      !(
        userInf.firstName === "" ||
        userInf.companyName === ""
      )
    ) {
      createBusinessAccount();
    }else{
      showNotification(t("notify.error"), t("account.create.missingNames"), "error");
    }
  };

  // An empty field is only an error when creating the account (see SignInForm).
  const handleEmailBlur = () => {
    if (userInf.email !== "" && !/\S+@\S+\.\S+/.test(userInf.email)) {
      setEmailError(true);
    }
  };

  const handlePasswordBlur = () => {
    if (userInf.password === "") {
      return;
    }
    if (userInf.password.length < 6) {
      setPasswordError(true);
    }
    setShowPassError(true);
  };

  const isBtnDisabled =
    accoutTypeSelected === "personal"
      ? !userInf.firstName || !userInf.lastName ||
      !userInf.email ||
      !userInf.password
      : !userInf.firstName || !userInf.lastName ||
      !userInf.companyName ||
      !userInf.email ||
      !userInf.password;

  if (!open) return null;

  const handleValueChange = (value, name) => {
    if (name === "email") {
      setEmailError(false);
    }

    if (name === "password") {
      setPasswordError(false);
    }
    setUserInf((prev) => ({ ...prev, [name]: value }));
  };

  const onSelectOption = (option) => {
    setSelectedOption(option ? option.value : "");
    setShowInputOption(Boolean(option && option.extraInput));
    setOptionInput("");
  }

  return ReactDOM.createPortal(
    <div className="modal">
      <div className="modal-content"></div>
      {accountStatus === "not-created" ? (
        <div
          className={`createAccountForm mx-[16px] w-[90%] max-w-[${width ? width : "792px"}] max-h-[90%] overflow-y-auto`}
        >
          <div
            className={`createAccountFormHeader ${
              !showSelectAccountType && "mb-2"
            }`}
          >
            {!showSelectAccountType && accountType === "business" ? (
              <h2 className="createAccountFormTitle">
                {t("account.create.titleBusiness")}
              </h2>
            ) : !showSelectAccountType && accountType === "personal" ? (
              <h2 className="createAccountFormTitle">
                {t("account.create.titlePersonal")}
              </h2>
            ) : (
              showSelectAccountType && (
                <h2 className="createAccountFormTitle">{t("account.create.title")}</h2>
              )
            )}
            <Close
              className="createAccountCloseIcon"
              onClick={() => closeModel()}
            />
          </div>

          {showSelectAccountType && (
            <h3 className="createAccountFormSpan">{t("account.create.selectType")}</h3>
          )}
          <div
            className={
              showSelectAccountType ? "createAccountFormContainerAdd" : ""
            }
          >
            {showSelectAccountType && (
              <div className="createAccountFormAccountType">
                <div
                  className={
                    accoutTypeSelected === "personal"
                      ? "createAccountFormTypeOption chosenAccountBorder"
                      : "createAccountFormTypeOption" + (joinTeamParam && joinTeamToken ? " opacity-50" : "")
                  }
                  onClick={() => joinTeamParam && joinTeamToken ? "": setAccountTypeSelected("personal")}
                >
                  <div className="createAccountFormTypeOptionHead">
                    <Personal className="personalIcon" />
                    <h3 className="createAccountFormTypeOptionHeadTitle">
                      {t("account.create.personal")}
                    </h3>
                  </div>
                  <span className="createAccountFormTypeOptionSpan">
                    {t("account.create.personalText")}
                  </span>
                </div>

                <div
                  className={
                    accoutTypeSelected === "business"
                      ? "createAccountFormTypeOption chosenAccountBorder"
                      : "createAccountFormTypeOption"
                  }
                  onClick={() => setAccountTypeSelected("business")}
                >
                  <div className="createAccountFormTypeOptionHead">
                    <Business className="personalIcon" />
                    <h3 className="createAccountFormTypeOptionHeadTitle">
                      {t("account.create.business")}
                    </h3>
                  </div>
                  <span className="createAccountFormTypeOptionSpan">
                    {t("account.create.businessText")}
                  </span>

                  <div
                    className="createAccountFormTypeOptionListItem"
                    style={{ marginTop: 10 }}
                  >
                    <Check className="createAccountFormTypeOptionListItemIcon" />
                    <span className="createAccountFormTypeOptionListItemText">
                      {t("account.create.businessClients")}
                    </span>
                  </div>

                  <div className="createAccountFormTypeOptionListItem">
                    <Check className="createAccountFormTypeOptionListItemIcon" />
                    <span className="createAccountFormTypeOptionListItemText">
                      {t("account.create.businessTeam")}
                    </span>
                  </div>

                  <div className="createAccountFormTypeOptionListItem">
                    <Check className="createAccountFormTypeOptionListItemIcon" />
                    <span className="createAccountFormTypeOptionListItemText">
                      {t("account.create.businessPayLater")}
                    </span>
                  </div>
                </div>
              </div>
            )}

            <div className="createAccountFormContainerAddingForm">
              {referral && accoutTypeSelected === "business" && !joinTeamParam && (
                <div className="createAccountReferral" data-testid="signup-referral">
                  <b>{referral.firmName ? t("account.create.referralInvited", { firm: referral.firmName }) : t("account.create.referralFrom", { firm: referral.code.toUpperCase() })}</b>
                  {" "}{referralBenefit(referral, t)}
                </div>
              )}
              <div className="signInFormContainer">
                <FormTextInput
                  email={false}
                  incorrect={false}
                  placeholder={t("field.firstName")}
                  clearInputIcon={false}
                  value={userInf?.firstName}
                  name={"firstName"}
                  onChange={handleValueChange}
                  // onKeyDown={(e) =>
                  //   e.key === "Enter" && accoutTypeSelected === "personal"
                  //     ? triggerPersonalAccount()
                  //     : createBusinessAccount()
                  // }
                />
              </div>

              <div className="signInFormContainer">
                <FormTextInput
                  email={false}
                  incorrect={false}
                  placeholder={t("field.lastName")}
                  clearInputIcon={false}
                  value={userInf?.lastName}
                  name={"lastName"}
                  onChange={handleValueChange}
                  // onKeyDown={(e) =>
                  //   e.key === "Enter" && accoutTypeSelected === "personal"
                  //     ? triggerPersonalAccount()
                  //     : createBusinessAccount()
                  // }
                />
              </div>

              {(accountType === "business" ||
                accoutTypeSelected === "business") && (
                <div className="signInFormContainer">
                  <FormTextInput
                    email={false}
                    incorrect={false}
                    placeholder={t("account.create.companyName")}
                    clearInputIcon={false}
                    value={userInf?.companyName}
                    name={"companyName"}
                    disabled={joinTeamParam && joinTeamToken && userInf.companyName !== ""}
                    onChange={handleValueChange}
                    // onKeyDown={(e) =>
                    //   e.key === "Enter" && accoutTypeSelected === "personal"
                    //     ? triggerPersonalAccount()
                    //     : createBusinessAccount()
                    // }
                  />
                </div>
              )}

              {accoutTypeSelected === "business" && !joinTeamParam && !referral && (
                showReferralField ? (
                  <div className="signInFormContainer">
                    <FormTextInput
                      email={false}
                      incorrect={referralInputError}
                      placeholder={t("account.create.referralCode")}
                      clearInputIcon={false}
                      value={referralInput}
                      name={"referralCode"}
                      onBlur={checkTypedReferral}
                      onChange={(value) => { setReferralInput(value); setReferralInputError(false); }}
                    />
                    {referralInputError && <div className="RegisterFormInputValidation">{t("account.create.referralUnknown")}</div>}
                  </div>
                ) : (
                  <button type="button" className="createAccountReferralToggle" onClick={() => setShowReferralField(true)}>
                    {t("account.create.referralHave")}
                  </button>
                )
              )}

              <div className="signInFormContainer">
                <FormTextInput
                  email={true}
                  incorrect={emailError || Boolean(emailTypoFix(userInf?.email))}
                  placeholder={t("field.email")}
                  clearInputIcon={true}
                  onBlur={handleEmailBlur}
                  value={userInf?.email}
                  name={"email"}
                  onChange={handleValueChange}
                  // onKeyDown={(e) =>
                  //   e.key === "Enter" && accoutTypeSelected === "personal"
                  //     ? triggerPersonalAccount()
                  //     : createBusinessAccount()
                  // }
                />
                <EmailTypoHint email={userInf?.email} onFix={(fix) => handleValueChange(fix, "email")} />
              </div>

              {emailError ? (
                <div className="RegisterFormInputValidation">
                  {t("account.invalidEmailFormat")}
                </div>
              ) : null}

              <div className="signInFormContainer">
                <FormTextInput
                  showPasswordIcon={true}
                  password={true}
                  incorrect={passwordError}
                  placeholder={t("account.password")}
                  onBlur={handlePasswordBlur}
                  value={userInf?.password}
                  name={"password"}
                  onChange={handleValueChange}
                  // onKeyDown={(e) =>
                  //   e.key === "Enter" && accoutTypeSelected === "personal"
                  //     ? triggerPersonalAccount()
                  //     : createBusinessAccount()
                  // }
                />
              </div>

              {showPassError && (
                <span
                  className={`passwordValidation ${
                    passwordError
                      ? "passwordError"
                      : userInf?.password.length >= 6
                      ? "passwordSuccess"
                      : "passwordDefault"
                  }`}
                >
                  <Check className="passwordCheck" />
                  {t("account.passwordRule")}
                </span>
              )}

            {!signedIn && askHear && 
              <div className="mt-4">
                <h4 className="quotePrimaryTitle">{t("account.create.hearTitle")}</h4>
                <HowDidYouHearSelect id="accountHowDidYouHear" selectedOption={selectedOption} inputText={optionInput} onSelect={onSelectOption} onInputChange={setOptionInput} />
              </div>
              }

              <div className="SubmitForm">
                <button
                  className="SubmitFormButton"
                  disabled={isBtnDisabled || isLoading || passwordError || (askHear && !isHowDidYouHearAnswered(selectedOption, optionInput))}
                  // The field keeps the focus until the click: on phones its blur moved
                  // this button between the press and the release, and the tap was lost.
                  onMouseDown={(e) => e.preventDefault()}
                  onClick={() => {
                    handleEmailBlur();
                    handlePasswordBlur();
                    return accoutTypeSelected === "personal"
                      ? triggerPersonalAccount()
                      : triggerBusinessAccount();
                  }}
                >
                  {t(submitButton)}
                  {isLoading && <Loader className="btnLoader" />}
                </button>
              </div>

              <div className="RegisterToHaveSignIn">
                <span className="RegisterToHaveSignInText">
                  {t("account.create.haveAccount")}
                </span>
                <span
                  className="RegisterToHaveSignInSpan"
                  onClick={() => openLoginForm()}
                >
                  {t("account.create.signIn")}
                </span>
              </div>
            </div>
          </div>
        </div>
      ) : null}

      {accountStatus === "created" ? (
        <AccountCreated
          closeAccountCreated={closeAccountCreated}
          accoutTypeSelected={accoutTypeSelected}
        />
      ) : null}
    </div>,
    modalRoot
  );
}
